// extracted by mini-css-extract-plugin
export default {"mainContainer":"app_mainContainer__F2VV+","mainContainer__content":"app_mainContainer__content__w078+"};